import React, {useEffect, useState} from 'react';
import {checkDate, generateMapBackground, isLeagueEditionEnding} from '../../../utils';
import {useHistory, withRouter, useParams} from "react-router-dom";
import moment from 'moment';
import {extendMoment} from 'moment-range';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import {cancelMatchSchedule, getMatchDetails, sendSchedulingComplaints, uploadMatchPhoto} from "../../../services/matches";
import {NotificationManager} from "react-notifications";
import MySwal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import {Form, Row} from "react-bootstrap";
import Collapse from "react-bootstrap/Collapse";
import {useTranslation} from "react-i18next";

// React Components
import Header from '../../../components/Header';
import ScheduleDay from '../../../components/ScheduleDay';
import Modal from '../../../components/Modal';
import ResultsDialog from '../../../components/ResultsDialog';
import ScheduleDialog from '../../../components/ScheduleDialog';
import GameCard from '../../../components/GameCard';
import InputTextArea from "../../../components/InputTextArea/InputTextArea";
import InputRadio from '../../../components/InputRadio/InputRadio';

// Icons
import AddPhotoIcon from "../../../assets/images/add_photo.svg";
import ChatBubbleIcon from "react-ionicons/lib/IosChatbubblesOutline";
import WhatsAppIcon from "../../../assets/images/logos/logo_whatsapp_green.svg";
import FacebookIcon from "../../../assets/images/logos/logo_facebook_green.svg";

// CSS Files
import './styles.css';
import ImageCropper from '../../../components/ImageCropper/ImageCropper';
import heic2any from 'heic2any';

const SwalReact = withReactContent(MySwal);

const GamePage = (props) => {
   const hiddenMatchPhoto = React.useRef(null);
   const [matchDetails, setmatchDetails] = useState(null);
   const [showLocationModal, setShowLocationModal] = useState(false);
   const [insertResultsModal, setInsertResultsModal] = useState(false);
   const [editScheduleModal, setEditScheduleModal] = useState(false);
   const [openThisWeekAvailabilities, setOpenThisWeekAvailabilities] = useState(false);
   const [openNextWeekAvailabilities, setOpenNextWeekAvailabilities] = useState(false);
   const [openWeekAfterAvailabilities, setOpenWeekAfterAvailabilities] = useState(false);
   const [showCropModal, setShowCropModal] = useState(false);
   const [selectedImage, setSelectedImage] = useState(null);
   const history = useHistory();
   const { t } = useTranslation();
   let {matchId} = useParams();
   let scheduledDate;
   const matchPhotoAspectOptions = [
      { label: 'Landscape', value: 4 / 3, icon: 'landscape' },
      { label: 'Square', value: 1, icon: 'square' },
      { label: 'Portrait', value: 3 / 4, icon: 'portrait' },
   ];

   useEffect(() => {
      (async () => {
         let matchDetails = await getMatchDetails(matchId);
         setmatchDetails(matchDetails);

         if(props.played) {
            window.FB.init({
               appId: process.env.FACEBOOK_APP_ID,
               status: true,
               cookie: true,
               oauth: true,
               xfbml: true,
               version: 'v16.0',
            });
         }

      })()
   }, []);

   if (!matchDetails)
      return null;

   const fixScheduleHours = (date) => {
      let minutes = date.getMinutes();

      if (minutes > 30) {
         date.setHours(date.getHours() + 1)
         date.setMinutes(0);
      } else {
         if (minutes > 0 && minutes < 30) {
            date.setMinutes(30);
         }
      }

      return date;
   }

   const buildAbsencePeriod = (reason, startDate, endDate, source) => {
      if (!reason || !startDate || !endDate) return null;

      return {
         reason,
         source,
         startDate: new Date(startDate),
         endDate: new Date(endDate)
      };
   }

   const translateAbsenceReason = reason => {
      const absenceReasonTranslations = {
         "Lesão": t("notify_absence_page.absence_reasons.injury"),
         "Trabalho/férias": t("notify_absence_page.absence_reasons.work_vacation"),
         "Procuro substituta/o": t("notify_absence_page.absence_reasons.looking_for_sub"),
         "Queremos desistir": t("notify_absence_page.absence_reasons.want_to_quit")
      };

      return absenceReasonTranslations[reason] || reason;
   }

   const formatAbsenceNotice = (reason, startDate, endDate) => {
      const dates = t("to_schedule_page.prevented_to_from", { interpolation: { escapeValue: false }, from: moment(startDate).format('DD/MM/YYYY'), to: moment(endDate).format('DD/MM/YYYY') });

      return t("to_schedule_page.scheduling_prevented_for_dates", { interpolation: { escapeValue: false }, dates, reason: translateAbsenceReason(reason) });
   }

   const opponentHasAbsence = matchDetails.opponent_enrollment_state === "absent" && matchDetails.opponent_absence_reason;
   const absencePeriods = [
      buildAbsencePeriod(matchDetails.absence_reason, matchDetails.absence_start_date, matchDetails.absence_end_date, "current"),
      buildAbsencePeriod(matchDetails.opponent_absence_reason, matchDetails.opponent_absence_start_date, matchDetails.opponent_absence_end_date, "opponent")
   ].filter(Boolean);

   const cancelMatch = () => {
      let cancelReasonRef = '';
      let didMyTeamCancelRef= true;

      const CancelMatchPopup = (props) => {
         const [reason, setReason] = useState('');
         const [didMyTeamCancel, setDidMyTeamCancel] = useState(true);
         let timeUntilMatch = moment().diff(moment(matchDetails.match_date), 'hours');

         useEffect(() => {
            cancelReasonRef = reason;
            didMyTeamCancelRef = didMyTeamCancel;
         }, [reason, didMyTeamCancel]);

         return <div className={"cancel-popup"}>
            {(timeUntilMatch > -24 && timeUntilMatch <= 0) &&
               <>
                  <p>{t("scheduled_page.cancel_match_popup.less_24h_notice")}</p>
               </>
            }

            {timeUntilMatch > 0 &&
               <p>{t("scheduled_page.cancel_match_popup.past_date_notice")}</p>
            }

            {(timeUntilMatch <= -24 || (timeUntilMatch > -24 && timeUntilMatch < 0)) &&
               <p>{t("scheduled_page.cancel_match_popup.responsibility_and_reason")}</p>
            }

            <div className={"text-left mt-3 mb-3"}>
               <InputRadio text={t("scheduled_page.cancel_match_popup.who_cancelled")} handleChange={(e) => {setDidMyTeamCancel(e.target.value)}} firstRadioText={t("scheduled_page.cancel_match_popup.us")} secondRadioText={t("scheduled_page.cancel_match_popup.them")} checked={didMyTeamCancel}/>
            </div>

            <InputTextArea text={t("scheduled_page.cancel_match_popup.reason")} className={"text-left mb-0"} name={'reason'} rows={"3"} handleChange={(e) => {setReason(e.target.value)}}/>
         </div>
      }

      SwalReact.fire({
         customClass: {
            content: "cancel-popup-content",
            input: 'cancel-popup-input mb-0',
            actions: 'cancel-popup-actions',
         },
         titleText: t("scheduled_page.cancel_match_popup.title"),
         html: (
            <CancelMatchPopup/>
         ),
         showCancelButton: true,
         cancelButtonText: t("common.close"),
         confirmButtonText: t("common.send"),
         allowOutsideClick: false,
         allowEscapeKey: false,
         preConfirm: async () => {
            return {
               'cancelReason': cancelReasonRef,
               'didMyTeamCancel': didMyTeamCancelRef
            };
         }
      }).then(async (res) => {
         if (res.dismiss === MySwal.DismissReason.cancel) {
            MySwal.close();
         } else {
            try {
               await cancelMatchSchedule(matchId, res.value.cancelReason, res.value.didMyTeamCancel);
               MySwal.fire({
                  html: matchDetails.n_cancellations > 0
                     ? `<p>${t("scheduled_page.cancel_match_popup.success_alert")}</p>`
                     : `<p>${t("scheduled_page.cancel_match_popup.success")}</p>`,
                  allowOutsideClick: false
               }).then(() => {
                  history.push("/my-games");
               })
            } catch (e) {
               MySwal.close();
               NotificationManager.error(t("common.form.errors.general"), t("common.error"), 4000);
            }
         }
      })
   }

   const populateScheduleDays = (week) => {
      if (!week.all_availabilities)
         return null;
      return (
         <>
            {week?.all_availabilities?.length === 0 && week?.partial_availabilities?.length === 0
               ? <p className={"no-availability"}>{t("to_schedule_page.no_availability")}</p>
               : <>
                  <>
                     {week?.all_availabilities?.length !== 0 &&
                        <>
                           <p className={"availability-type"}>{t("to_schedule_page.availability_all")}</p>

                           <Row className={"m-0 timeslot-container"}>
                              {week?.all_availabilities?.map((timeSlot, key) => {
                                 return <React.Fragment key={key}>
                                    <ScheduleDay
                                       key={key}
                                       timeSlot={timeSlot}
                                       matchId={matchId}
                                       clubId={matchDetails.location?.id}
                                       clubs={matchDetails.clubs}
                                       leagueEditionStartDate={matchDetails?.league_edition_start_date}
                                       leagueEditionEndDate={matchDetails?.league_edition_end_date}
                                    />
                                 </React.Fragment>
                              })}
                           </Row>
                        </>
                     }
                  </>

                  {week?.partial_availabilities?.length !== 0 &&
                     <>
                        <p className={"availability-type one-available"}>{t("to_schedule_page.availability_one")}</p>

                        <Row className={"m-0 timeslot-container"}>
                           {week?.partial_availabilities?.map((timeSlot, key) => {
                              return <React.Fragment key={key}>
                                 <ScheduleDay
                                    key={key}
                                    timeSlot={timeSlot}
                                    matchId={matchId}
                                    clubId={matchDetails.location?.id}
                                    clubs={matchDetails.clubs}
                                    leagueEditionStartDate={matchDetails.league_edition_start_date}
                                    leagueEditionEndDate={matchDetails.league_edition_end_date}
                                 />
                              </React.Fragment>
                           })}
                        </Row>
                     </>
                  }
               </>
            }
         </>
      )
   }

   if (matchDetails.state === "scheduled") {
      scheduledDate = new Date(matchDetails?.match_date).setHours(parseInt(matchDetails?.match_date?.slice(11, 13)));
   }

   const canInsertUnaccomplishedResult = props.played &&
      matchDetails.state === "played" &&
      matchDetails.unaccomplished &&
      !matchDetails.has_result &&
      matchDetails.contains_current_user &&
      isLeagueEditionEnding(matchDetails.league_edition_end_date);

   return (<div style={{minHeight: "100vh", height: "fit-content", backgroundColor: "#F5F4F3"}}>
      <Header
         class={"mb-0"}
         showHeaderExtras
         showBackButton
         headerButtonRight={<div className={"cursor-pointer"}>
            <ChatBubbleIcon className="mt-n1" fontSize="30px" onClick={() => history.push(`/my-games/game/${matchId}/contacts`, matchDetails)}/>
         </div>}
         headerBarContent={<div className={"header-jornada"}>
            <span className="jornada-weeknumber">{t("common.game_week").toUpperCase()} {matchDetails?.week_number}</span>
            <span>
          {(moment(matchDetails.start_date).format(`${t("common.date_formatting.day")} MMM`) + " - " + moment(matchDetails.end_date).format(`${t("common.date_formatting.day")} MMM`))}
        </span>
         </div>}
         headerLight>
      </Header>
      <div className="game-page-wrapper">
         <div className="game-page-container">
            <span className="game-page-title">{matchDetails.league_title}</span>
            <div className="game-page-body">
               <span>{matchDetails.municipality}</span>
               <div className="players-container">
                  <div className={"player a-top" + (matchDetails?.teams?.a[0]?.image === "/img/faceless-photo.svg" ? " no-profile" : "")}>
                     <img
                        src={matchDetails?.teams?.a[0]?.image === "/img/faceless-photo.svg" ? "" : matchDetails?.teams?.a[0]?.image}
                        alt={matchDetails?.teams?.a[0]?.image === "/img/faceless-photo.svg" ? "" : matchDetails?.teams?.a[0]?.name}
                     />
                  </div>
                  <div className={"player a-bottom" + (matchDetails?.teams?.a[1]?.image === "/img/faceless-photo.svg" ? " no-profile" : "")}>
                     <img
                        src={matchDetails?.teams?.a[1]?.image === "/img/faceless-photo.svg" ? "" : matchDetails?.teams?.a[1]?.image}
                        alt={matchDetails?.teams?.a[1]?.image === "/img/faceless-photo.svg" ? "" : matchDetails?.teams?.a[1]?.name}
                     />
                  </div>
                  <div className={"player b-top" + (matchDetails?.teams?.b[0]?.image === "/img/faceless-photo.svg" ? " no-profile" : "")}>
                     <img
                        src={matchDetails?.teams?.b[0]?.image === "/img/faceless-photo.svg" ? "" : matchDetails?.teams?.b[0]?.image}
                        alt={matchDetails?.teams?.b[0]?.image === "/img/faceless-photo.svg" ? "" : matchDetails?.teams?.b[0]?.name}/>
                  </div>
                  <div className={"player b-bottom" + (matchDetails?.teams?.b[1]?.image === "/img/faceless-photo.svg" ? " no-profile" : "")}>
                     <img
                        src={matchDetails?.teams?.b[1]?.image === "/img/faceless-photo.svg" ? "" : matchDetails?.teams?.b[1]?.image}
                        alt={matchDetails?.teams?.b[1]?.image === "/img/faceless-photo.svg" ? "" : matchDetails?.teams?.b[1]?.name}/>
                  </div>
               </div>
               <span className="game-date-text">{matchDetails.match_date ? moment(matchDetails.match_date).utc().format(`${t("common.date_formatting.day")} MMM - HH[h]mm`) : t("to_schedule_page.to_schedule")}</span>
            </div>
            <div className="game-page-court"/>
            <div className="d-flex w-100">
               <div className="d-flex flex-column justify-content-center align-items-start team-a-names">
                  <p className={"player-name"}>{matchDetails?.teams?.a[0]?.name}</p>
                  <p className={"player-name"}>{matchDetails?.teams?.a[1]?.name}</p>
               </div>

               <div className="d-flex flex-column justify-content-center align-items-end team-b-names">
                  <p className={"player-name"}>{matchDetails?.teams?.b[0]?.name}</p>
                  <p className={"player-name"}>{matchDetails?.teams?.b[1]?.name}</p>
               </div>
            </div>
         </div>
      </div>
      {props.scheduled ? <>
         <div className="header-separator-wrapper">
            <div className="location-container" onClick={() => setShowLocationModal(true)} style={generateMapBackground(matchDetails.location)}>
               <div className="location-header-wrapper">
                  <div className="location-header">{t("scheduled_page.venue")}</div>
               </div>
               <div className="location-body">
                  <span className="game-location-name">{matchDetails.location?.name}</span>
                  <span className="game-location-address">{matchDetails.location?.address}</span>
                  <span className="game-location-postal">{matchDetails.location?.postal}</span>
               </div>
            </div>
         </div>
         {matchDetails?.contains_current_user && isLeagueEditionEnding(matchDetails?.league_edition_end_date) &&
            <div className="actions-wrapper my-3">
               <Button
                  onClick={() => {
                     if (new Date(matchDetails?.match_date) > new Date()) {
                        NotificationManager.error(t("scheduled_page.errors.future_date"), 4000);
                     } else {
                        setInsertResultsModal(true)
                     }
                  }}
                  className="w-100 btn-thick mb-2"
                  variant={"primary"}
               >
                  {t("scheduled_page.insert_results")}
               </Button>
               <Button onClick={() => setEditScheduleModal(true)} className="w-100 btn-thick mb-2" variant={"secondary"}>{t("scheduled_page.edit_scheduling")}</Button>
               <Button onClick={() => cancelMatch()} className="w-100 btn-thick mb-2" variant={"secondary"}>{t("scheduled_page.cancel_scheduling")}</Button>
            </div>
         }
         <>
            <Modal show={showLocationModal}
                   onHide={() => setShowLocationModal(false)}>
               <>
                  <ButtonGroup vertical className="w-100">
                     <Button onClick={() => {
                        window.open(`https://www.google.com/maps/search/?api=1&query=${matchDetails.location?.lat}%2C${matchDetails.location?.long}`, "_blank")
                     }} className="w-100 btn-thick" variant={"secondary"}>{t("scheduled_page.check_map")}</Button>
                     <a href={`tel:${matchDetails.location?.phone_number}`} className={"w-100"}>
                        <Button onClick={() => {
                        }} className="w-100 btn-thick phone-btn" variant={"secondary"}>{t("scheduled_page.call")}</Button>
                     </a>
                     <Button onClick={() => {
                        window.open(matchDetails.location?.site_url, "_blank")
                     }} className="w-100 btn-thick" variant={"secondary"}>{t("scheduled_page.website")}</Button>
                  </ButtonGroup>
                  <Button onClick={() => setShowLocationModal(false)} className="w-100 mt-2 btn-thick" variant={"secondary"}>{t("common.close")}</Button>
               </>
            </Modal>
            <Modal show={insertResultsModal}
                   onHide={() => setInsertResultsModal(false)}
                   mobileFullWidth>
               <ResultsDialog
                  matchState={matchDetails.state}
                  leagueFormat={matchDetails.league_format}
                  teams={matchDetails.teams}
                  leagueEditionEndDate={matchDetails.league_edition_end_date}
                  close={() => setInsertResultsModal(false)}
               />
            </Modal>
         </>
      </> : props.played ? <>
         <div className="header-separator-wrapper">
            <GameCard results gameInfo={matchDetails}/>
         </div>
         {canInsertUnaccomplishedResult &&
            <div className="actions-wrapper my-3">
               <Button
                  onClick={() => setInsertResultsModal(true)}
                  className="w-100 btn-thick mb-2"
                  variant={"primary"}
               >
                  {t("scheduled_page.insert_results")}
               </Button>
            </div>
         }
         <Modal show={insertResultsModal}
                onHide={() => setInsertResultsModal(false)}
                mobileFullWidth>
            <ResultsDialog
               matchState={matchDetails.state}
               leagueFormat={matchDetails.league_format}
               teams={matchDetails.teams}
               leagueEditionEndDate={matchDetails.league_edition_end_date}
               close={() => setInsertResultsModal(false)}
            />
         </Modal>
         {matchDetails.contains_current_user &&
            <div className="game-photo-wrapper">
               {matchDetails.photo !== "/photos/original/missing.png" ?
                  <>
                     <div className={"share-btns-container"}>
                        <p className={"mr-2"}>{t("played_match_page.share")}</p>
                        <img onClick={() => {
                           window.FB.ui({
                              method: 'share',
                              href: `https://tournaments.padelbox.pt/matches/${matchDetails.id}/photo`,
                              hashtag: "#ligapadelbox"
                           }, function (response) {
                              if (response && !response.error_message) {
                                 NotificationManager.success(t("played_match_page.photo_share_success"), t("common.success"), 4000,);
                              }
                           });
                        }} src={FacebookIcon} alt={"share on facebook"} className={"cursor-pointer"}/>

                        <a href={`https://wa.me/?text=${encodeURIComponent("https://tournaments.padelbox.pt/matches/" + matchDetails.id + "/photo\n\n@ligapadelbox\n#ligapadelbox").replace(/\n/g, '%0A')}`}>
                           <img src={WhatsAppIcon} alt={"share on whatsapp"} className={"ml-2"}/>
                        </a>
                     </div>
                     <div className="game-photo">
                        <img src={matchDetails.photo} alt="" />
                     </div>
                  </>
                  :
                 <div className={"insert-photo"} onClick={() => {
                    hiddenMatchPhoto.current.click();
                 }}>
                    <img className={"text-center pb-3"} src={AddPhotoIcon} />
                    <p className={"text-center font-weight-bold"}>{t("played_match_page.add_photo")}</p>
                    <input
                      type="file"
                      ref={hiddenMatchPhoto}
                      style={{ display: "none" }}
                      accept="image/*"
                      onChange={async (e) => {
                         const file = e.target.files[0];
                         if (!file) return;
                         const isHeic = file.type === 'image/heic' || file.type === 'image/heif' ||
                           file.name.toLowerCase().endsWith('.heic') || file.name.toLowerCase().endsWith('.heif');
                         try {
                           const source = isHeic
                             ? await heic2any({ blob: file, toType: 'image/jpeg', quality: 0.9 })
                             : file;
                           const blob = source instanceof Blob ? source : source[0];
                           setSelectedImage(URL.createObjectURL(blob));
                           setShowCropModal(true);
                         } catch (err) {
                           console.error('Image load error:', err);
                         }
                      }}
                    />
                 </div>
               }
            </div>
         }
         <div className="separator-container">
            <div className="location-container no-pointer" style={generateMapBackground(matchDetails.location)}>
               <div className="location-header-wrapper">
                  <div className="location-header">{t("scheduled_page.venue")}</div>
               </div>
               <div className="location-body">
                  <span className="game-location-name">{matchDetails.location?.name}</span>
                  <span className="game-location-address">{matchDetails.location?.address}</span>
                  <span className="game-location-postal">{matchDetails.location?.postal}</span>
               </div>
            </div>
         </div>
      </> : <>
         {matchDetails.contains_current_user && isLeagueEditionEnding(matchDetails.league_edition_end_date) &&
            <div className="scheduler-wrapper">
               <div className="scheduler-container">
                  {opponentHasAbsence &&
                     <div className="alert alert-info mb-3" role="alert">
                        {formatAbsenceNotice(matchDetails.opponent_absence_reason, matchDetails.opponent_absence_start_date, matchDetails.opponent_absence_end_date)}
                     </div>
                  }
                  <h3 style={{marginBottom: 20}}>{t("to_schedule_page.schedule_match")}</h3>
                  <span className="schedule-reminder-label">{t("to_schedule_page.schedule_match_alert")}</span>
                  <div className="avail-btns-container d-flex flex-column">
                     <div className={"show-avail-btn mb-3"}>
                        <Button
                           className={"w-100 btn btn-secondary"}
                           onClick={() => setOpenThisWeekAvailabilities(!openThisWeekAvailabilities)}
                           aria-expanded={openThisWeekAvailabilities}
                        >
                           <div className="d-inline avail-btn-tooltip">
                              {t("to_schedule_page.check_availabilities")}
                              <div className="d-inline teams team-a ml-1">A</div> {t("to_schedule_page.and")} <div className="d-inline teams team-b">B</div>
                           </div>
                           <br/>
                           {t("to_schedule_page.this_week")}
                        </Button>
                        <Collapse className={"p-3"} in={openThisWeekAvailabilities}>
                           <div>
                              {populateScheduleDays(matchDetails?.schedule_days?.this_week)}
                           </div>
                        </Collapse>
                     </div>

                     <div className={"show-avail-btn mb-3"}>
                        <Button
                           className={"w-100 btn btn-secondary" + (moment(matchDetails.league_edition_end_date).diff(moment(), 'days') < 7 ? " disabled" : "")}
                           onClick={() => setOpenNextWeekAvailabilities(!openNextWeekAvailabilities)}
                           aria-expanded={openNextWeekAvailabilities}
                           disabled={moment(matchDetails.league_edition_end_date).diff(moment(), 'days') < 7}
                        >
                           <div className="d-inline avail-btn-tooltip">
                              {t("to_schedule_page.check_availabilities")}
                              <div className="d-inline teams team-a ml-1">A</div> {t("to_schedule_page.and")} <div className="d-inline teams team-b">B</div>
                           </div>
                           <br/>
                           {t("to_schedule_page.next_week")}
                        </Button>
                        <Collapse className={"p-3"} in={openNextWeekAvailabilities}>
                           <div>
                              {populateScheduleDays(matchDetails?.schedule_days?.next_week)}
                           </div>
                        </Collapse>
                     </div>

                     <div className={"show-avail-btn"}>
                        <Button
                           className={"w-100 btn btn-secondary" + (moment(matchDetails.league_edition_end_date).diff(moment(), 'days') < 15 ? " disabled" : "")}
                           onClick={() => setOpenWeekAfterAvailabilities(!openWeekAfterAvailabilities)}
                           aria-expanded={openWeekAfterAvailabilities}
                           disabled={moment(matchDetails.league_edition_end_date).diff(moment(), 'days') < 15}
                        >
                           <div className="d-inline avail-btn-tooltip">
                              {t("to_schedule_page.check_availabilities")}
                              <div className="d-inline teams team-a ml-1">A</div> {t("to_schedule_page.and")} <div className="d-inline teams team-b">B</div>
                           </div>
                           <br/>
                           {t("to_schedule_page.following_week")}
                        </Button>
                        <Collapse className={"p-3"} in={openWeekAfterAvailabilities}>
                           <div>
                              {populateScheduleDays(matchDetails?.schedule_days?.week_after)}
                           </div>
                        </Collapse>
                     </div>
                  </div>
               </div>
            </div>
         }

         {matchDetails.contains_current_user && isLeagueEditionEnding(matchDetails.league_edition_end_date) &&
            <div>
               <div className="actions-wrapper">
                  <Button className="w-100 mt-3 mb-3" variant={"primary"} onClick={() => {
                     setEditScheduleModal(true);
                  }}>{t("to_schedule_page.schedule_another_date")}</Button>
               </div>

               <div className="actions-wrapper">
                  <Button className="w-100 mt-0 mb-3" variant={"primary"} onClick={() => {
                     let selectedReasonRef = ''
                     let descriptionRef = ''

                     const PopupContent = () => {
                        const [selectedReason, setSelectedReason] = useState('');
                        const [description, setDescription] = useState('');

                        const reasons = [
                           t("to_schedule_page.difficulties_popup.team_a"),
                           t("to_schedule_page.difficulties_popup.team_b"),
                           t("to_schedule_page.difficulties_popup.unavailable_opponents"),
                           t("to_schedule_page.difficulties_popup.other")
                        ];

                        useEffect(() => {
                           selectedReasonRef = selectedReason
                        }, [selectedReason]);

                        useEffect(() => {
                           descriptionRef = description
                        }, [description]);

                        return <div>
                           <div className={"mb-2"}>
                              <Form.Label className={"mb-0"}>{t("to_schedule_page.difficulties_popup.difficulty")}</Form.Label>

                              {reasons.map((reason, key) => {
                                 return <Form.Check
                                    id={`reason-${key}`}
                                    key={key}
                                    type="radio"
                                    label={reason}
                                    value={reason}
                                    checked={selectedReason === reason}
                                    onChange={(e) => setSelectedReason(e.target.value)}
                                    className={"text-left"}
                                 />
                              })}
                           </div>

                           <InputTextArea handleChange={(e) => {setDescription(e.target.value)}} rows={"3"} text={t("to_schedule_page.difficulties_popup.description")}/>
                        </div>
                     }

                     MySwal.fire({
                        titleText: t("common.attention").toUpperCase(),
                        text: t("to_schedule_page.difficulties_popup.alert"),
                        confirmButtonText: "Ok",
                        showCancelButton: true,
                        cancelButtonText: t("common.cancel")
                     }).then((res) => {
                        if (res.value) {
                           SwalReact.fire({
                              customClass: {
                                 content: 'text-left',
                                 actions: 'mt-0'
                              },
                              titleText: t("to_schedule_page.difficulties_popup.opponents"),
                              html: (
                                 <PopupContent/>
                              ),
                              confirmButtonText: t("common.send"),
                              preConfirm: async () => {
                                 if (selectedReasonRef === '') {
                                    NotificationManager.error(t("to_schedule_page.errors.no_reason"), t("common.error"), 4000);
                                    return false;
                                 } else if (selectedReasonRef === 'Outra' && descriptionRef === '') {
                                    NotificationManager.error(t("to_schedule_page.errors.no_reason"), t("common.error"), 4000);
                                    return false;
                                 }

                                 try {
                                    await sendSchedulingComplaints(matchId, selectedReasonRef, descriptionRef);
                                 } catch (e) {
                                    NotificationManager.error(t("common.form.errors.general_alt"), t("common.error"), 4000);
                                    return "server_error";
                                 }
                              }
                           }).then(async (res) => {
                              if (res.dismiss === MySwal.DismissReason.backdrop) {
                                 SwalReact.close();
                              }

                              if (res.value && res.value !== 'server_error') {
                                 NotificationManager.success(t("to_schedule_page.difficulties_popup.success"), t("common.success"), 2000);
                                 history.push("/my-games");
                              }
                           })
                        }
                     })
                  }}>
                     {t("to_schedule_page.send_difficulties")}
                  </Button>
               </div>

               {matchDetails.state === "suspended" &&
                  <div className="actions-wrapper">
                     <Button className="w-100" variant={"primary"} onClick={() => {
                        MySwal.fire({
                           titleText: t("scheduled_page.suspend_match_popup.title"),
                           text: matchDetails.notes,
                           confirmButtonText: "Ok"
                        }).then(() => {
                           MySwal.close();
                        });
                     }}>{t("scheduled_page.show_match_notes")}</Button>
                  </div>
               }
            </div>
         }
      </>}
      <Modal show={editScheduleModal}
             onHide={() => setEditScheduleModal(false)}
             mobileFullWidth>
         <ScheduleDialog
            content={{
               matchId: matchId,
               isScheduled: props.scheduled,
               matchOriginalSchedule: props.scheduled ? scheduledDate : fixScheduleHours(checkDate(new Date(), new Date(matchDetails.league_edition_start_date), new Date(matchDetails.league_edition_end_date))),
               clubs: matchDetails.clubs,
               leagueEditionStartDate: new Date(matchDetails.league_edition_start_date),
               leagueEditionEndDate: new Date(matchDetails.league_edition_end_date),
               absenceReason: matchDetails.absence_reason,
               absenceStartDate: new Date(matchDetails.absence_start_date),
               absenceEndDate: new Date(matchDetails.absence_end_date),
               absencePeriods
            }}
            close={() => setEditScheduleModal(false)}
         />
      </Modal>
      {showCropModal && (
        <ImageCropper
          image={selectedImage}
          aspect={4 / 3}
          aspectOptions={matchPhotoAspectOptions}
          onUpload={async (formData) => await uploadMatchPhoto(matchId, formData.get('image'))}
          onUploadSuccess={() => {
             MySwal.fire({
                allowOutsideClick: false,
                titleText: t("common.success"),
                text: t("played_match_page.thank_you")
             }).then(() => {
                history.push("/my-games");
             });
             setShowCropModal(false);
             setSelectedImage(null);
             if (hiddenMatchPhoto.current) hiddenMatchPhoto.current.value = null;
          }}
          onCancel={() => {
             setShowCropModal(false);
             setSelectedImage(null);
             if (hiddenMatchPhoto.current) hiddenMatchPhoto.current.value = null;
          }}
        />
      )}
   </div>);
};

export default withRouter(GamePage);
